import { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { ArrowRight, CheckCircle2, ChevronDown } from "lucide-react";
import api from "@/lib/api";
import Seo from "@/components/Seo";
import PublicHeader from "@/components/PublicHeader";
import PublicFooter from "@/components/PublicFooter";

export default function ServiceLanding() {
  const { slug } = useParams();
  const [detail, setDetail] = useState(null);
  const [openFaq, setOpenFaq] = useState(0);
  const nav = useNavigate();

  useEffect(() => {
    setDetail(null);
    api.get(`/public/service/${slug}`).then(({ data }) => setDetail(data)).catch(() => setDetail(false));
  }, [slug]);

  if (detail === false) return (
    <div className="min-h-screen bg-panel-bg text-panel-text"><PublicHeader /><div className="p-20 text-center">Servis bulunamadı. <Link to="/" className="text-brand-500">Ana sayfa</Link></div></div>
  );

  return (
    <div className="min-h-screen bg-panel-bg text-panel-text">
      {detail && <Seo title={detail.meta_title} description={detail.meta_description} />}
      <PublicHeader />

      <section className="mx-auto max-w-3xl px-4 sm:px-6 pt-12 pb-10">
        <div>
          <div className="flex items-center gap-3">
            {detail && <img src={detail.icon} alt={detail.name} className="h-14 w-14 rounded-2xl bg-white p-1.5 object-contain" />}
            <span className="text-xs font-semibold text-panel-secondary bg-panel-card border border-panel-border rounded-full px-3 py-1">SMS Onay Servisi</span>
          </div>
          <h1 className="mt-5 font-head text-4xl sm:text-5xl font-extrabold tracking-tight">
            {detail?.name || "..."} <span className="text-brand-500">SMS Onay</span>
          </h1>
          <p className="mt-4 text-panel-secondary text-base sm:text-lg max-w-xl leading-relaxed">
            {detail?.name} için ucuz ve güvenilir sanal numara ile anında onay kodu alın. 180+ ülke, iade garantisi.
          </p>
          <div className="mt-6 flex gap-3">
            <button onClick={() => nav("/kayit")} data-testid="landing-cta" className="btn-blue rounded-xl px-6 h-12 font-semibold flex items-center gap-2">
              Numara Al <ArrowRight size={18} />
            </button>
            <Link to="/giris" className="rounded-xl px-6 h-12 font-semibold flex items-center card hover:border-brand-500 transition-colors">Giriş Yap</Link>
          </div>
        </div>
      </section>

      {/* benefits */}
      <section className="mx-auto max-w-7xl px-4 sm:px-6 grid sm:grid-cols-3 gap-4">
        {["Yüksek başarı oranı ve anlık teslim", "SMS gelmezse otomatik iade", "Rank sistemi ile toplu alım indirimi"].map((t) => (
          <div key={t} className="card p-5 flex items-start gap-3">
            <CheckCircle2 className="text-emerald-500 shrink-0" size={20} />
            <span className="text-sm text-panel-secondary">{t}</span>
          </div>
        ))}
      </section>

      {/* SEO text */}
      {detail?.seo_html && (
        <section className="mx-auto max-w-4xl px-4 sm:px-6 mt-14">
          <article className="leading-relaxed text-panel-secondary [&_h2]:font-head [&_h2]:text-2xl [&_h2]:font-bold [&_h2]:text-panel-text [&_h2]:mt-6 [&_h2]:mb-3 [&_h3]:font-head [&_h3]:text-lg [&_h3]:font-semibold [&_h3]:text-panel-text [&_h3]:mt-5 [&_h3]:mb-2 [&_ul]:list-disc [&_ul]:pl-6 [&_li]:mt-1 [&_strong]:text-panel-text"
            dangerouslySetInnerHTML={{ __html: detail.seo_html }} />
        </section>
      )}

      {/* FAQ */}
      {detail?.faq?.length > 0 && (
        <section className="mx-auto max-w-3xl px-4 sm:px-6 mt-14">
          <h2 className="font-head text-2xl font-bold text-center mb-6">{detail.name} S.S.S</h2>
          <div className="space-y-3">
            {detail.faq.map((f, i) => (
              <div key={i} className="card overflow-hidden">
                <button onClick={() => setOpenFaq(openFaq === i ? -1 : i)} className="w-full flex items-center justify-between gap-4 p-4 text-left font-semibold">
                  {f.q} <ChevronDown size={18} className={`transition-transform ${openFaq === i ? "rotate-180" : ""}`} />
                </button>
                {openFaq === i && <div className="px-4 pb-4 text-sm text-panel-secondary">{f.a}</div>}
              </div>
            ))}
          </div>
        </section>
      )}

      <PublicFooter />
    </div>
  );
}
